import camelcaseKeys from 'camelcase-keys'

export class Settings {
  constructor (params = {}) {
    const { email, languageCode, hasPassword, facilityId, displayCurrencyId } = camelcaseKeys(params)
    this.email = email || null
    this.languageCode = languageCode || null
    this.hasPassword = hasPassword
    this.facilityId = facilityId || null
    this.displayCurrencyId = displayCurrencyId || null
  }
}
